import { render } from "./Table.ce.vue?vue&type=template&id=22c0076e&scoped=true"
import script from "./Table.ce.vue?vue&type=script&lang=js"
export * from "./Table.ce.vue?vue&type=script&lang=js"

import _style_0 from "./Table.ce.vue?vue&type=style&index=0&id=22c0076e&inline&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-22c0076e"]])

export default __exports__